import { Popover } from 'antd'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { WarningIcon } from 'screens/Rostering/RotaBuilder/common/components/icons'
import { ReactNode } from 'react'

const WarningPopover = ({
  children,
  warningsData,
}: {
  children: ReactNode
  warningsData: string[]
}) => {
  const warnings = warningsData

  return (
    <Popover
      placement="top"
      showArrow
      trigger="hover"
      arrow={{ pointAtCenter: true }}
      content={
        <ContentContainer>
          <TitleText level={2}>Warnings</TitleText>
          {warnings.map((warning) => (
            <WarningRow key={warning}>
              <WarningIcon />
              <WarningText> {warning}</WarningText>
            </WarningRow>
          ))}
        </ContentContainer>
      }
    >
      {children}
    </Popover>
  )
}

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const TitleText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`

const WarningRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const WarningText = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

export default WarningPopover
